<template lang="pug">
footer
  div {{ content }}
  div Pełna treść klauzuli -> &nbsp;
    span.rodo-btn(@click="rodoOpened = true") RODO
  .overlay(v-if="rodoOpened" @click.prepend="rodoOpened = false")
    .popup
      .popup-content
        .close(@click="rodoOpened = false") ✕
        .popup-header Zasady przetwarzania danych osobowych
        div {{ rodo }}
</template>

<script>
import Content from '../contents/footer'
import RODO from '../contents/rodo'
export default {
  name: "Footer",
  data() {
    return {
      content: '',
      rodo: '',
      rodoOpened: false
    }
  },
  mounted() {
    this.content = Content
    this.rodo = RODO
  }
}
</script>

<style lang="scss" scoped>
.rodo-btn {
  font-weight: 600;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.overlay {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0,0,0,.65);
  .popup {
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70vw;
    height: 80vh;
    overflow-y: auto;
    .close {
      position: absolute;
      display: block;
      font-size: 30px;
      cursor: pointer;
      top: 15px;
      right: 35px;
    }
    .popup-header {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      width: 100%;
      margin-bottom: 10px;
    }
    .popup-content {
      background: #fff;
      color: #000;
      padding: 20px 35px;
    }
  }
}
</style>
